import { Link, useNavigate } from "react-router-dom";
import "./header.scss";

// Default back glyph. Same 24px stroke language as the BottomNavigation
// icons (stroke="currentColor", round caps) so both shell bars match.
export function HeaderBackIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}

function HeaderActionIcon({ icon }) {
  if (!icon) {
    return <HeaderBackIcon />;
  }
  // Legacy callers pass an imported `.svg` asset (a URL string).
  if (typeof icon === "string") {
    return (
      <img className="HeaderActions-icon-img" src={icon} alt="" aria-hidden="true" />
    );
  }
  return icon;
}

// One side slot of the Header: either a navigation link, a history-back
// button (`target === -1`, with `fallback` for deep links with no history),
// or an invisible spacer that keeps the title centered.
function HeaderActions({
  target,
  fallback = "/",
  label = "بازگشت",
  icon,
  onClick,
  hidden = false,
}) {
  const navigate = useNavigate();

  const goBack = () => {
    const idx = window.history.state?.idx;
    if (typeof idx === "number" && idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback, { replace: true });
    }
  };

  if (hidden && !target && !onClick) {
    return <span className="HeaderActions HeaderActions--spacer" aria-hidden="true" />;
  }

  if (onClick) {
    return (
      <button
        type="button"
        className="HeaderActions"
        onClick={onClick}
        aria-label={label}
        title={label}
      >
        <HeaderActionIcon icon={icon} />
      </button>
    );
  }

  if (target === -1) {
    return (
      <button
        type="button"
        className="HeaderActions"
        onClick={goBack}
        aria-label={label}
        title={label}
      >
        <HeaderActionIcon icon={icon} />
      </button>
    );
  }

  if (target) {
    return (
      <Link to={target} className="HeaderActions" aria-label={label} title={label}>
        <HeaderActionIcon icon={icon} />
      </Link>
    );
  }

  return <span className="HeaderActions HeaderActions--spacer" aria-hidden="true" />;
}

export default HeaderActions;
